/**
 * <team-carousel>
 *
 * Filters the team slides by league. Filtering is client side because every
 * team already ships in the markup — the pills only decide which slides stay
 * visible, then the shared carousel is asked to re-measure.
 *
 * `shop_by_team` entries arrive in the metaobject's own order, and Liquid has no
 * way to sort on a metaobject field, so they are put in A–Z order here. Slides
 * from merchant-configured blocks carry no `data-name` and keep the order the
 * merchant set.
 */
if (!customElements.get('team-carousel')) {
  customElements.define(
    'team-carousel',
    class TeamCarousel extends HTMLElement {
      constructor() {
        super();
        this.onFilterClick = this.onFilterClick.bind(this);
      }

      connectedCallback() {
        this.sortByName();

        this.filters = Array.from(this.querySelectorAll('[data-league-filter]'));
        for (const filter of this.filters) {
          filter.addEventListener('click', this.onFilterClick);
        }
      }

      disconnectedCallback() {
        for (const filter of this.filters || []) {
          filter.removeEventListener('click', this.onFilterClick);
        }
      }

      sortByName() {
        const named = Array.from(this.querySelectorAll('[data-name]'));
        if (named.length < 2) return;

        const list = named[0].parentElement;
        const ordered = named.sort((a, b) => a.dataset.name.localeCompare(b.dataset.name));
        for (const slide of ordered) {
          list.appendChild(slide);
        }

        this.querySelector('scroll-carousel')?.dispatchEvent(new CustomEvent('carousel:refresh'));
      }

      get slides() {
        return Array.from(this.querySelectorAll('[data-league]'));
      }

      onFilterClick(event) {
        const league = event.currentTarget.dataset.leagueFilter;

        for (const filter of this.filters) {
          filter.setAttribute('aria-pressed', String(filter === event.currentTarget));
        }

        for (const slide of this.slides) {
          const matches = league === '' || slide.dataset.league === league;
          slide.hidden = !matches;
        }

        const carousel = this.querySelector('scroll-carousel');
        if (!carousel) return;

        /* reset: true asks the carousel to return to the first slide.
           Writing track.scrollLeft from here was unreliable on iOS, where the
           write animated and Safari re-snapped to the slide the filter had
           just hidden. See resetScroll in component-scroll-carousel.js. */
        carousel.dispatchEvent(new CustomEvent('carousel:refresh', { detail: { reset: true } }));
      }
    },
  );
}
